var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LiefengCascader',{attrs:{"dataScopeList":['44-4401-440106-440106008','44-4401-440106-440106009']}})}
var staticRenderFns = []

export { render, staticRenderFns }